module.exports = __webpack_public_path__ + "d94e20c1/img/delete-icon.eb7de062.svg";